import type { ChangeEvent } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { cn } from '@/libs/tailwind';

type SelectDropdownProps = {
  className?: string;
  options: Array<{ name: string; value: string }>;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  value: string;
  loading: boolean;
};

export function SelectDropdown({ className, options, onChange, value, loading }: SelectDropdownProps) {
  const t = useTranslations('SelectDropdown');

  return (
    <div className="relative inline-block w-fit">
      <select
        className={cn(
          'w-full appearance-none pl-[12px] pr-[36px] py-[4px] border rounded-sm border-[#d4d6ec] font-bold text-[16px]',
          className,
        )}
        onChange={onChange}
        value={value}
        disabled={loading}
      >
        {loading
          ? (
              <option>{t('loading')}</option>
            )
          : (
              options.map(option => (
                <option key={option.value} value={option.value}>
                  {option.name}
                </option>
              ))
            )}
      </select>
      <ChevronDownIcon
        className="pointer-events-none absolute right-[10px] top-1/2 -translate-y-1/2"
        size={20}
        color="black"
      />
    </div>
  );
};
